<article *ngIf="apiError" class="message is-danger">
  <div class="message-body">
    <b>{{apiError.notification}}</b>
    <span *ngFor="let error of apiError.errors" class="is-block">{{error.key}}: {{error.error}}</span>
  </div>
</article>
<div [formGroup]="form">

   <div class="is-flex-tablet">
      <div class="field is-flex-grow-1">
        <label class="label">Neues Passwort?</label>
        <div class="control">
          <input formControlName="password"
                 [ngClass]="isFormRequestError('password') ? 'is-danger' : ''" class="input"
                 type="password"
                 placeholder="Neues Passwort?" value=""/>
          <p *ngIf="isFormRequestError('password')" class="help is-danger">Bitte hinterlegen Sie ein Passwort mit
            mindestens 6 Zeichen.</p>
        </div>
      </div>
      <div class="field is-flex-grow-1 ml-4-tablet">
        <label class="label">Neues Passwort wiederholen</label>
        <div class="control">
          <input formControlName="passwordRetype" [ngClass]="isFormRequestError('passwordRetype') ? 'is-danger' : ''"
                 class="input" type="password"
                 placeholder="Neues Passwort wiederholen?" value=""/>
          <p *ngIf="isFormRequestError('passwordRetype')" class="help is-danger">Die Passwörter stimmen nicht überein.</p>
        </div>
      </div>
    </div>
  <div class="mt-4">
    <iw-shop-forms-submit-button  [formStatus]="formStatus" [submitLabel]="'Neues Passwort speichern'"
                                (submit)="submit()"></iw-shop-forms-submit-button >
  </div>
</div>


